import type { AppState, ErrorCode } from './driver';

// The pairing hash stays in the URL after pairing, so a reload re-dials the original
// session first. After a network switch that room is still busy, or the dial itself
// freezes — failures where the stored reconnect root is the right way in.
// handshake_failed (wrong PIN/QR, crypto), wasm_load_failed and rate_limited are not
// network faults and must stay terminal.
const FALLBACK_CODES: ReadonlySet<ErrorCode> = new Set<ErrorCode>([
  'unknown_session',
  'room_busy',
  'ws_open_failed',
  'handshake_timeout',
]);

/** True when a failed hash-path start should retry via the stored reconnect record (same agent only — the caller checks). */
export function shouldFallBackToReconnect(st: AppState): boolean {
  return st.kind === 'error' && FALLBACK_CODES.has(st.code);
}
